export const logout = () => {
  //  clear storage
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("user");

  //  redirect
  window.location.href = "/";
};